// extracted by mini-css-extract-plugin
module.exports = {"loanBenefitsContainer":"Bl6fT","benefitsRow":"_2cd_T","benefitCardContainer":"_7KzQL","container":"_3kHA6","textContainer":"_3VfKM"};